<template>
  <div>
    <div v-if="loading" style="padding:20px">
      <div class="ui active centered inline large loader"></div>
    </div>
    <div v-else class="ui grid" style="padding:20px">
      <div class="row">
        <div class="six wide column">
          <div class="ui header">Configuration</div>
        </div>
      </div>
      <div class="row">
        <div class="fourteen wide column">
          <div class="ui form">
            <div class="field">
              <div class="ui checkbox labelCursorFix">
                <input type="checkbox" data-lpignore="true" v-model="oneTenthDown" id="checkbox334455">
                <label for="checkbox334455">
                  <span style="color: red;"><i class="warning circle icon"></i>Alerts:</span> 
                  warn at every <b>0.1 rating drop</b> not just <i class="icons"><i class="yellow fitted star outline icon"></i><i class="yellow fitted half star icon"></i></i>
                </label>
              </div>
            </div>
            <div class="field">
              <div class="ui checkbox labelCursorFix">
                <input type="checkbox" data-lpignore="true" v-model="oneTenthUp" id="checkbox334456">
                <label for="checkbox334456">
                  <span style="color: green;"><i class="checkmark circle icon"></i>Notifications:</span> 
                  &nbsp; by <b>0.1 improvements</b> not just <i class="icons"><i class="yellow fitted star outline icon"></i><i class="yellow fitted half star icon"></i></i>
                </label>
              </div>
            </div>
            <div class="field">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              &nbsp;&nbsp;&nbsp;&nbsp;
              Report review count drops greater than or equal to
              <div class="ui right labeled input" style="width:90px;">
                <input type="number" min="1" size="3" v-model="reviewCountDropMinimumThreshold"/>
                <div class="ui basic label">reviews</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="six wide column">
          <button v-bind:class="dirty ? 'ui primary button' : 'ui disabled primary button'" v-on:click="save()">Save</button>
          <button class="ui basic button" @click="close()">Close </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      loading: true,
      oneTenthUp: false,
      oneTenthDown: false,
      oneTenthUpOrig: false,
      oneTenthDownOrig: false,
      reviewCountDropMinimumThreshold: 1,
      reviewCountDropMinimumThresholdOrig: 1,
      dirty: false,
    }
  },
  methods: {
    load: function () {
      this.$http.get('/api/sentinel/watchdogtype/settings/starRatingRecentChange').then((response) => {
        this.loading = false
        this.oneTenthUp = response.body.oneTenthPrecisionUp
        this.oneTenthDown = response.body.oneTenthPrecisionDown
        this.reviewCountDropMinimumThreshold = response.body.reviewCountDropMinimumThreshold
        this.oneTenthUpOrig = this.oneTenthUp
        this.oneTenthDownOrig = this.oneTenthDown
        this.reviewCountDropMinimumThresholdOrig = this.reviewCountDropMinimumThreshold
      }, (response) => {
        this.loading = false
      })
    },
    close: function () {
      this.$parent.showConfiguration = false
    },
    save: function () {
      this.$http.put('/api/sentinel/watchdogtype/settings/starRatingRecentChange', {
        oneTenthPrecisionUp: this.oneTenthUp,
        oneTenthPrecisionDown: this.oneTenthDown,
        reviewCountDropMinimumThreshold: this.reviewCountDropMinimumThreshold,
      }).then((response) => {
        this.oneTenthUpOrig = this.oneTenthUp
        this.oneTenthDownOrig = this.oneTenthDown
        this.reviewCountDropMinimumThresholdOrig = this.reviewCountDropMinimumThreshold
        this.updateDirty()
      }, (response) => {
        this.loading = false
      })
    },
    updateDirty: function () {
      this.dirty = this.oneTenthUp !== this.oneTenthUpOrig || this.oneTenthDown !== this.oneTenthDownOrig || this.reviewCountDropMinimumThreshold !== this.reviewCountDropMinimumThresholdOrig
    }
  },
  created: function () {
    this.load()
  },
  watch: {
    oneTenthUp: function () {
      this.updateDirty()
    },
    oneTenthDown: function () {
      this.updateDirty()
    },
    reviewCountDropMinimumThreshold: function () {
      this.updateDirty()
    },
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// StarRatingRecentChangeConfig.vue?17cdd380